import type { TFunction } from "i18next";

export interface AddressBasedTemplateFormValues {
  name: string;
  lookback_years: number;
  minimum_duration_months: number;
  apply_residency_rules_to_current_address: boolean;
  enable_maximum_price?: boolean;
  maximum_price?: Record<string, number | undefined> | null;
  id?: string;
  is_active?: boolean;
  check_arguments?: Record<string, unknown> | null;
}

export interface AddressBasedTemplatePageConfig {
  apiPathPrefix: string;
  settingsPathPrefix: string;
  /** Must call `t` with a string literal so i18next-parser extracts the key. */
  templateLabel: (t: TFunction) => string;
  testIdPrefix: string;
  /** Defaults to `ADDRESS_BASED_TEMPLATE_DEFAULTS.DEFAULT_LOOKBACK_YEARS`. */
  defaultLookbackYears?: number;
  /** Adds the `check_arguments.maximum_price` cap (editable on create, read-only on detail). */
  showMaximumPrice?: boolean;
}

export const ADDRESS_BASED_TEMPLATE_DEFAULTS = {
  MIN_DURATION_MONTHS: 1,
  MAX_DURATION_MONTHS: 100,
  DEFAULT_DURATION_MONTHS: 6,
  MIN_LOOKBACK_YEARS: 1,
  MAX_LOOKBACK_YEARS: 99,
  DEFAULT_LOOKBACK_YEARS: 10,
} as const;

/** The API accepts a single currency with an integer amount, or null for no cap. */
export function toMaximumPricePayload(
  values: Pick<
    AddressBasedTemplateFormValues,
    "enable_maximum_price" | "maximum_price"
  >
): Record<string, number> | null {
  if (!values.enable_maximum_price) {
    return null;
  }
  const entry = Object.entries(values.maximum_price ?? {}).find(
    ([, amount]) => amount
  );
  return entry ? { [entry[0]]: entry[1] as number } : null;
}
